export enum NodeType {
  PROMPT_INPUT = 'PROMPT_INPUT',
  MEDIA_UPLOAD = 'MEDIA_UPLOAD',
  IMAGE_GENERATOR = 'IMAGE_GENERATOR',
  VIDEO_GENERATOR = 'VIDEO_GENERATOR',
  VIDEO_ANALYZER = 'VIDEO_ANALYZER',
  IMAGE_EDITOR = 'IMAGE_EDITOR',
  AUDIO_GENERATOR = 'AUDIO_GENERATOR',
  TEXT_NODE = 'TEXT_NODE',
  SCRIPT_NODE = 'SCRIPT_NODE',
  VIDEO_COMPOSE = 'VIDEO_COMPOSE',
  PANORAMA_GENERATOR = 'PANORAMA_GENERATOR',
  GROUP = 'GROUP',
}

export enum NodeStatus {
  IDLE = 'IDLE',
  WORKING = 'WORKING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
